import React from 'react';

const STATS = [
  {
    num: (
      <>
        <span className="text-sky">2.4</span>
      </>
    ),
    caption: 'falls per resident, per year, in long-term care — nearly double for those with cognitive impairment',
  },
  {
    num: (
      <>
        <span className="text-sky">80</span>%
      </>
    ),
    caption: 'of senior falls happen in the bathroom, most during or right after a shower',
  },
  {
    num: (
      <>
        $<span className="text-sky">205K</span>
      </>
    ),
    caption: 'average annual cost a single community absorbs from shower-related falls',
  },
];

function StatBand() {
  return (
    <section className="py-[50px] bg-cream-hi">
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <div className="bg-cream shadow-nu-in rounded-nu px-6 py-10 md:px-11 md:py-10 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-[30px]">
          {STATS.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-display text-[2.6rem] font-bold text-navy-deep">{stat.num}</div>
              <div className="text-[0.88rem] text-navy mt-1.5 leading-[1.4]">{stat.caption}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatBand;
